import React, { ReactNode } from 'react';

interface TabProps {
  label: string;
  children: ReactNode;
  className?: string;
  eventKey?: string;
}

const Tab: React.FC<TabProps> = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

export default Tab;